<div>
  <div class="title-change-box">
    <div class="title-change" *ngFor="let item of AllInvoice" (click)="changeCompare(item)" [class.active-state]="item.selected">
      <span> {{ item.StatusTitle }}</span> <span class="title-time">{{ item.ShamsiCreatedDate }}</span>
    </div>
  </div>
</div>
<div class="security">
  <div class="details" *ngFor="let compare of CompareList">
    <div class="user-box">
      <div (click)="changeFactor = !changeFactor" class="state-header">
        {{ "ClientApp.FrontOffice.Review.SecurityReview.StateFactor" | translate }}
      </div>
      <div class="user-change" *ngIf="!changeFactor">
        <div class="title-user">{{ compare.CreatedUserName }}</div>
        <div class="title-user">{{ compare.CommandTitle }}</div>
        <div class="title-user" *ngIf="IsDelino">{{ "ClientApp.FrontOffice.Review.SecurityReview.OnlineFactor" | translate }}</div>
        <div *ngFor="let change of compare.Changes" class="title-user">{{ change?.Lookup?.Title }}</div>
        <div *ngFor="let change of compare.DepositHistory?.Changes" class="title-user">
          <span *ngIf="change.ChangedFieldCode">{{
            "ClientApp.FrontOffice.Review.SecurityReview." + (change.ChangedFieldCode | translateEnum : changedFieldCodeEnum) | translate
          }}</span>
          <span *ngIf="change.State">{{
            "ClientApp.FrontOffice.Review.SecurityReview." + (change.State | translateEnum : stateEnum) | translate
          }}</span>
        </div>
        <i class="icon-more_vert-o moreicon" tooltip="{{ compare.CreatedUserName }}"> </i>
      </div>
      <i class="icon-close-o close-icon" (click)="changeCompare(compare)"></i>
    </div>
    <div class="page" [class.open-chane-state]="!changeFactor">
      <div class="box">
        <header>
          <div class="header-title" (click)="showHeaderContent = !showHeaderContent">
            <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.FactorInformation" | translate }}</span>
            <i class="icon-chevron-up chevron" [class.rotate-icon]="showHeaderContent"></i>
          </div>
          <div class="header" [class.show-header-content]="!showHeaderContent">
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.CustomerName" | translate }} : </span
              ><span>{{ compare.CustomerDisplayName }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.ClearedUserName" | translate }} : </span
              ><span>{{ compare.ClearedUserName }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.CustomerCode" | translate }}: </span><span>{{ compare.CustomerNumber }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.TableTitle" | translate }} : </span><span>{{ compare.TableTitle }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.SalePriceTypeTitle" | translate }} : </span
              ><span>{{ compare.SalePriceTypeTitle }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.PhoneNumber" | translate }}: </span><span>{{ compare.PhoneNumber }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.WaiterName" | translate }} : </span><span>{{ compare.WaiterName }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.BranchName" | translate }}: </span><span>{{ compare.Branch?.Title }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.QuestNumber" | translate }} : </span><span>{{ compare.NumberOfGuests }}</span>
            </div>
            <div class="header-address">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.Address" | translate }}: </span><span>{{ compare.CustomerAddres }}</span>
            </div>
          </div>
        </header>
        <header *ngIf="compare.DepositHistory">
          <div class="header-title" (click)="showDepositHeaderContent = !showDepositHeaderContent">
            <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.Deposit" | translate }}</span>
            <i class="icon-chevron-up chevron" [class.rotate-icon]="showDepositHeaderContent"></i>
          </div>
          <div class="header" [class.show-header-content]="!showDepositHeaderContent">
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.ServingFoodDate" | translate }} : </span
              ><span>{{ compare.DepositHistory.ServingFoodDate | persianDate }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.ServingFoodTime" | translate }}: </span
              ><span>{{ compare.DepositHistory.ServingFoodTime }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.MealTime" | translate }} : </span
              ><span>{{ compare.DepositHistory.MealTime | translateEnum : mealTimeEnum }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.DeliveryType" | translate }} : </span
              ><span>{{ compare.DepositHistory.DeliveryType | translateEnum : deliveryTypeEnum }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.ClearType" | translate }}: </span
              ><span>{{ compare.DepositHistory.ClearType | translateEnum : clearTypeEnum }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.NumberOfPeople" | translate }} : </span
              ><span>{{ compare.DepositHistory.NumberOfPeople }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.NumberOfCooks" | translate }}: </span
              ><span>{{ compare.DepositHistory?.NumberOfCooks }}</span>
            </div>
            <div class="header-detail">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.DepositAmount" | translate }} : </span
              ><span>{{ compare.DepositHistory.DepositAmount }}</span>
            </div>
            <div class="header-address">
              <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.ServicesAmount" | translate }}: </span
              ><span>{{ compare.DepositHistory.ServicesAmount }}</span>
            </div>
            <div class="deposit-personnel-detail" *ngFor="let personnel of compare.DepositHistory.DepositPersonnelHistoryList">
              <span>
                {{ personnel.Amount }}
              </span>
              <span>
                {{ personnel.PersonnelTitle }}
              </span>
            </div>
          </div>
        </header>
        <section class="content" [class.close-header]="showHeaderContent">
          <div class="title">
            <span class="title-foodname">{{ "ClientApp.FrontOffice.Review.SecurityReview.FoodName" | translate }}</span>
            <span class="title-count">{{ "ClientApp.FrontOffice.Review.SecurityReview.Count" | translate }}</span>
            <span class="title-price">{{ "ClientApp.FrontOffice.Review.SecurityReview.Price" | translate }}</span>
            <span class="title-discount">{{ "ClientApp.FrontOffice.Review.SecurityReview.Discount" | translate }}</span>
            <span class="title-total">{{ "ClientApp.FrontOffice.Review.SecurityReview.TotalPrice" | translate }} </span>
          </div>
          <div *ngFor="let item of compare.Items" class="detail-box">
            <div class="detail" [class.up]="item.QuantityUp" [class.down]="item.QuantityDown">
              <span class="title-foodname" *ngIf="item.ItemTitle">{{ item.ItemTitle }}</span>
              <span class="title-foodname" *ngIf="!item.ItemTitle">-</span>
              <span [class.up]="item.QuantityUp" *ngIf="item.ItemTitle" [class.down]="item.QuantityDown" class="title-count">{{
                item.Quantity | number
              }}</span>
              <span class="title-price" *ngIf="item.ItemTitle">{{ item.UnitPrice + item.UnitAdditive | number }}</span>
              <span *ngIf="item.ItemTitle" [class.up]="item.RowDiscountPriceUp" [class.down]="item.RowDiscountPriceDown" class="title-discount"
                >{{ item.RowDiscountPrice | number }}
              </span>
              <span *ngIf="item.ItemTitle" [class.up]="item.TotalPriceUp" [class.down]="item.TotalPriceDown" class="title-total">{{
                (item.UnitPrice + item.UnitAdditive - ((item.UnitPrice + item.UnitAdditive) * item.RowDiscount) / 100) * item.Quantity | number
              }}</span>
            </div>
            <div *ngIf="item.ItemTitle" [class.description]="item.Description || item.DescriptionChange">{{ item.Description }}</div>
          </div>
        </section>
      </div>
      <footer>
        <div class="total-header" (click)="showFooterContent = !showFooterContent">
          <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.TotalPrice" | translate }} </span>
          <i class="icon-chevron-up chevron" [class.rotate-icon]="showFooterContent"></i>
        </div>
        <div class="footer-content" [class.show-footer]="showFooterContent">
          <div class="sum" [class.up]="compare.Totalup" [class.down]="compare.TotalDown">
            <span> {{ "ClientApp.FrontOffice.Review.SecurityReview.TotalPrice" | translate }} :</span><span>{{ compare.Total | number }}</span>
          </div>
          <div class="sum" [class.up]="compare.TotalDiscountup" [class.down]="compare.TotalDiscountDown">
            <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.Discount" | translate }}: </span><span>{{ compare.TotalDiscount | number }}</span>
          </div>
          <div class="sum" [class.up]="compare.ShippingCostup" [class.down]="compare.ShippingCostDown">
            <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.ShippingCost" | translate }}: </span
            ><span>{{ compare.ShippingCost | number }}</span>
          </div>
          <div class="sum" [class.up]="compare.TotalServiceup" [class.down]="compare.TotalServiceDown">
            <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.TotalService" | translate }}: </span
            ><span>{{ compare.TotalService | number }}</span>
          </div>
          <div class="sum" [class.up]="compare.TotalTaxup" [class.down]="compare.TotalTaxDown">
            <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.TotalTax" | translate }}: </span
            ><span>{{ compare.TotalTax + compare.TotalToll | number }}</span>
          </div>
          <div class="sum" [class.up]="compare.RoundingAmountup" [class.down]="compare.RoundingAmountDown">
            <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.RoundingAmount" | translate }} : </span
            ><span>{{ compare.RoundingAmount | number }}</span>
          </div>
          <div class="sum" [class.up]="compare.PayableTotalup" [class.down]="compare.PayableTotalDown">
            <span> {{ "ClientApp.FrontOffice.Review.SecurityReview.PayableTotal" | translate }}: </span
            ><span>{{ compare.PayableTotal | number }}</span>
          </div>
          <div class="sum" [class.up]="compare.PackingPriceup" [class.down]="compare.PackingPriceDown">
            <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.PackingPrice" | translate }} : </span
            ><span>{{ compare.PackingPrice | number }}</span>
          </div>
          <div class="sum" [class.up]="compare.Debitup" [class.down]="compare.DebitDown" *ngIf="compare.Debit > 0">
            <span> {{ "ClientApp.FrontOffice.Review.SecurityReview.Debit" | translate }} : </span><span>{{ compare.Debit | number }}</span>
          </div>
          <div class="sum" [class.up]="compare.Creditup" [class.down]="compare.CreditDown" *ngIf="compare.Credit > 0">
            <span>{{ "ClientApp.FrontOffice.Review.SecurityReview.Credit" | translate }} : </span><span>{{ compare.Credit | number }}</span>
          </div>
        </div>
      </footer>
    </div>
  </div>
</div>
